module.exports = __webpack_public_path__ + "img/dbd8bcb.jpg";